import styled from "@emotion/styled";

export const Container = styled.div`
  position: absolute;
  inset-block-start: 0;
  z-index: 2;

  display: flex;
  gap: 3px;

  inline-size: 100%;
  padding-block-start: 7px;
  padding-inline: 11px;

  ${props => props.theme.breakpoints.up("tablet")} {
    padding-block-start: 16px;
  }
`;

type StepProps = {
  $state: boolean;
};

export const Step = styled.div<StepProps>`
  display: block;
  flex-grow: 1;

  block-size: 2px;

  border-radius: 1px;

  background-color: ${({ $state }) => ($state === true ? "#ffffff" : "rgba(255, 255, 255, 0.4)")};
`;
